import ENDPOINTS from '../../const/endpoints';
export var authorizedBuyersLookupCacheKey = function (membershipNumber) {
    return [ENDPOINTS.authorizedBuyersLookup, { membershipNumber: membershipNumber }];
};
